import * as React from "react"
import { Badge } from "@/components/ui/badge"
import { useBookingT } from "@/hooks/use-translations"
import { cn } from "@/lib/utils"
import type { UiStatus } from "../api/types"
import { statusMeta } from "./statusModel"

type Props = {
  status: UiStatus
  className?: string
  showDot?: boolean
}

export function StatusBadge({ status, className, showDot = true }: Props) {
  const t = useBookingT()
  const meta = statusMeta(status)
  return (
    <Badge variant={meta.badgeVariant} className={cn("gap-1.5", className)}>
      {showDot && <span className={cn("size-1.5 rounded-full", meta.dotClass)} />}
      {t(meta.labelKey, meta.labelFallback)}
    </Badge>
  )
}
